import { InfiniteAutocomplete } from '@xefi/x-react/form';
import { type ComponentProps, useEffect, useState } from 'react';
import type { Filter } from '@/models/common';
type SearchFilterProps = Pick<ComponentProps<typeof InfiniteAutocomplete>, 'placeholder' | 'isFetching' | 'fetchNextPage' | 'hasNextPage' | 'className' | 'selectionIcon' | 'selectionMode' | 'classNames' | 'label' | 'labelPlacement'> & {
  items: {
    id: string;
    name: string;
  }[];
  isLoading?: boolean;
  setSearch: (value?: string) => void;
  setFilter: (filter: Filter | null) => void;
  makeFilter: (ids: string[]) => Filter;
  isError?: boolean;
  resetToken?: number;
  selectedKeys?: Set<string> | string[];
};
export const SearchFilter = ({
  items,
  setSearch,
  setFilter,
  makeFilter,
  resetToken,
  selectionMode = 'multiple',
  isLoading = false,
  isError,
  selectedKeys,
  ...restProps
}: SearchFilterProps) => {
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());
  useEffect(() => {
    setSelectedIds(new Set());
    setSearch(undefined);
    setFilter(null);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetToken]);
  useEffect(() => {
    if (selectedKeys) {
      const keysSet = selectedKeys instanceof Set ? selectedKeys : new Set(selectedKeys);
      setSelectedIds(keysSet);
    }
  }, [selectedKeys]);
  return <InfiniteAutocomplete {...restProps} popoverBackdrop='transparent' isLoading={isLoading} inputProps={{
    classNames: {
      inputWrapper: `border border-border bg-transparent group-data-[focus=true]:border-outline data-[focus-visible=true]:outline-0 data-[focus=true]:border-outline data-[hover=true]:bg-transparent data-[hover=true]:border-outline ${isError ? 'border-danger' : ''}`
    }
  }} items={items} selectedKeys={selectedIds} getItemKey={item => item.id} renderItem={item => item.name} radius='md' variant='bordered' selectionMode={selectionMode} onSearchChange={value => {
    setSearch(value);
  }} onSelectionChange={keys => {
    const incomingKeys = keys instanceof Set ? Array.from(keys) : [keys];
    const idSet = new Set<string>();
    incomingKeys.forEach(key => {
      if (key != null) {
        idSet.add(String(key));
      }
    });
    setSelectedIds(idSet);
    setSearch(undefined);
    if (idSet.size === 0) {
      setFilter(null);
    } else {
      setFilter(makeFilter(Array.from(idSet)));
    }
  }} />;
};